<div class="ppl-container-body">
    @for(notification of notifications; track notification) {
        <div class="alert alert-warning notification-alert" style="margin-bottom: 4px;">
            <p class="mb-0" [innerHTML]="notification"></p>
        </div>
    }
    <div class="ppl-container-head fake-revert">
        <h1 class="page-title-accessibility" tabindex="-1">Welcome, {{userData?.first_name}}!</h1>
    </div>
    <div class="ppl-container">
        
        <div class="ppl-content-container">
            
            @for( userProgram of userPrograms ; track userProgram; let idx = $index ){
                <ppl-card  [program]="userProgram" (emitSelectedProgram)="onProgramSelection($event)"></ppl-card>
            }@empty {
                <div> There are no Programs assigned. Please reach out to PPL admin.</div>
              }
        </div>
    </div>
</div>

<div class="filter-panel">
    <ng-template #SurveyDialog let-cancel="cancel">
        <div style="margin: 20px;">
            <ppl-survey-form [surveyData]="surveyData" (surveySubmitted)="handlePopUpClose()"></ppl-survey-form>
        </div>
    </ng-template>
</div>